import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, digitOnlyRegex } from "constants/validations";

/**
 * Schema for AAA member number validation.
 * Must be exactly 16 digits.
 */
export const aaaMemberNumberSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .length(16, { message: "AAA member number must be exactly 16 digits." })
    .regex(digitOnlyRegex, { message: "AAA member number must contain only digits." });

export const optionalAaaMemberNumberSchema = z.union([z.literal(""), aaaMemberNumberSchema]).optional();
